import React from 'react';
import { GridType } from '../types';

export type withSkeletonProps = {
  skeletonLoading?: boolean;
  grid?: GridType;
};

const withSkeleton = <P extends object>(
  Component: React.ComponentType<P>,
  SkeletonComponent: React.ComponentType<GridType>,
): React.FC<P & withSkeletonProps> => ({
  skeletonLoading = false,
  grid,
  ...props
}: withSkeletonProps) =>
  skeletonLoading ? (
    <SkeletonComponent row={grid?.row} col={grid?.col} />
  ) : (
    <Component {...(props as P)} grid={grid} />
  );

export default withSkeleton;
